import type { Filter } from '@pique/env/filter';

export const createTagFilter = (id: string): Filter => {
  return {
    type: 'filter',
    left: { type: 'ref', name: 'Tags' },
    funcName: 'contains all',
    args: [{ type: 'literal', value: [id] }],
  };
};

export const createTitleFilter = (titles: string[]): Filter => {
  return {
    type: 'filter',
    left: { type: 'ref', name: 'Title' },
    funcName: 'contains all',
    args: [{ type: 'literal', value: titles }],
  };
};
